import { connect } from 'react-redux';
import Dropdown from '../components/reference-data-dropdown';
import { getReferenceData } from './reference-data-actions';

const mapStateToProps = (state, ownProps) => ({
  data: state.referenceData.data,
  loadingState: state.referenceData.loadingState,
  errorState: state.referenceData.errorState,
  // When serviceCenterId is provided, it overrules the current navigationself
  serviceCenterId: ownProps.serviceCenterId || state.navigation.navigationSelf.serviceCenterId,
  fullScreen: state.planningBoard.fullScreen,
});

const mapDispatchToProps = { getReferenceData };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Dropdown);
